<script setup lang="ts">
import BaseSidebar from '~/components/molecules/BaseSidebar.vue'
import { useOrganization } from '~/composables/useOrganization'

const { organization } = useOrganization()
</script>

<template>
  <aside class="root">
    <BaseSidebar
      v-if="organization"
      :title="$t('個人設定')"
      :menus="[
        {
          to: { name: 'organizationId-myself-edit', params: { organizationId: organization.id } },
          text: $t('基本情報'),
        },
        {
          to: { name: 'organizationId-myself-passwordEdit', params: { organizationId: organization.id } },
          text: $t('パスワード変更'),
        },
      ]"
    />
  </aside>
</template>

<style scoped lang="scss">
.root {
  width: 260px;
}
</style>
